module.exports = __webpack_public_path__ + "img/un_full_screen.dfe55050.png";